<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ticket (Nº)</mat-label>
                                <input matInput id="txtTicket" #txtTicket maxlength="20" currencyMask
                                    [options]="{ thousands: '', decimal: '', precision: 0 }" formControlName="Ticket">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtTicket.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Ticket)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Placa Carreta</mat-label>
                                <input matInput id="txtPlacaCarreta" #txtPlacaCarreta maxlength="7"
                                    formControlName="Placa_carreta">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintScoreBoard}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPlacaCarreta.value.length}} / 7</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Placa_carreta)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Transportadora</mat-label>
                                <mat-select formControlName="Transportadora" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterTransportadora($event.target.value)">
                                    <mat-option *ngFor="let item of listTransportadora" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>

                                <!-- <input type="text" placeholder="Transportadora" matInput [matAutocomplete]="auto"
                                    formControlName="Transportadora" id="txtTransportadora" maxlength="20"
                                    #txtTransportadora>
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let itemTransportadora of filteredOptions | async"
                                        [value]="itemTransportadora.name">
                                        {{itemTransportadora.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <!-- <mat-hint align="end">{{txtTransportadora.value.length}} / 20</mat-hint> -->
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">NFP Nota Fiscal
                                </mat-label>
                                <input matInput id="txtNfpNotaFiscal" #txtNfpNotaFiscal maxlength="80"
                                    formControlName="Nfp_nota_fiscal">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtNfpNotaFiscal.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Nfp_nota_fiscal)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md-9 col-xs-6 col-sm-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">DT (p/ Planta Comercial) ou AVISO DE ENTREGA (p/
                                    Planta Pré-Comercial)
                                </mat-label>
                                <input matInput id="txtDt" #txtDt maxlength="80" formControlName="Dt">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtDt.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Dt)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1 col-md-3 col-xs-6 col-sm-6 btnAlignSelf">
                            <button mat-flat-button color="primary" matTooltip="Leitor DT" (click)="openDialog()"
                                class="btnSize" [disabled]="disableBtnDt">
                                <i class="{{iconBarCodeField}}"></i> Leitor DT
                            </button>
                        </div>
                    </div>

                    <!-- <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">NFP Nota Fiscal
                                </mat-label>
                                <input matInput id="txtNfpNotaFiscal" #txtNfpNotaFiscal maxlength="80"
                                    formControlName="Nfp_nota_fiscal">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtNfpNotaFiscal.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Nfp_nota_fiscal)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div> -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Chegada no Pátio Data
                                </mat-label>
                                <input matInput id="txtChgPatioData" #txtChgPatioData maxlength="10" mask="d0/M0/0000"
                                    formControlName="Chegada_patio_data" (blur)="makeCalculations()"
                                    (blur)="calcHarvestWeek()" (blur)="alertaData()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtChgPatioData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Chegada_patio_data)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Chegada no Pátio Hora
                                </mat-label>
                                <input matInput id="txtChgPatioDataHora" #txtChgPatioData maxlength="5" mask="Hh:m0"
                                    formControlName="Chegada_patio_hora" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtChgPatioData.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Chegada_patio_hora)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo Percurso {{hintHourResult}}
                                </mat-label>
                                <input matInput id="txtTempoPercurso" #txtTempoPercurso maxlength="5" readonly
                                    formControlName="Tempo_percurso" currencyMask class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtTempoPercurso.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_percurso)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Distância do Campo (Km)
                                </mat-label>
                                <input matInput id="txtDistCampo" #txtDistCampo maxlength="20" readonly
                                    formControlName="Distancia_campo" currencyMask class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDistCampo.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Distancia_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Pesagem Data
                                </mat-label>
                                <input matInput id="txtPesagemData" #txtPesagemData maxlength="10" mask="d0/M0/0000"
                                    formControlName="Dt_pesagem_data" (blur)="makeCalculations()"
                                    (blur)="calcHarvestWeek()" (blur)="alertaData()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPesagemData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Dt_pesagem_data)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Pesagem Hora
                                </mat-label>
                                <input matInput id="txtPesagemHora" #txtPesagemHora maxlength="5" mask="Hh:m0"
                                    formControlName="Dt_pesagem_hora">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPesagemHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Dt_pesagem_hora)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">


                    <!-- <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">NFP Nota Fiscal
                                </mat-label>
                                <input matInput id="txtNfpNotaFiscal" #txtNfpNotaFiscal maxlength="80"
                                    formControlName="Nfp_nota_fiscal">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtNfpNotaFiscal.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Nfp_nota_fiscal)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div> -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Chegada no Pátio Data
                                </mat-label>
                                <input matInput id="txtChgPatioData" #txtChgPatioData maxlength="10" mask="d0/M0/0000"
                                    formControlName="Chegada_patio_data" (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtChgPatioData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Chegada_patio_data)}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Chegada no Pátio Hora
                                </mat-label>
                                <input matInput id="txtChgPatioDataHora" #txtChgPatioData maxlength="5" mask="Hh:m0"
                                    formControlName="Chegada_patio_hora" (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtChgPatioData.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Chegada_patio_hora)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo Percurso {{hintHourResult}}
                                </mat-label>
                                <input matInput id="txtTempoPercurso" #txtTempoPercurso readonly
                                    formControlName="Tempo_percurso" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtTempoPercurso.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_percurso)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Distância do Campo (Km)
                                </mat-label>
                                <input matInput id="txtDistCampo" #txtDistCampo maxlength="20"
                                    formControlName="Distancia_campo" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDistCampo.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Distancia_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">

                        <!-- Card parte 4 -->

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Descarga Data</mat-label>
                                <input matInput id="txtIniDescargaData" #txtIniDescargaData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Inicio_descarga_data"
                                    [dropSpecialCharacters]="false" (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtIniDescargaData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_descarga_data)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Descarga Hora</mat-label>
                                <input matInput id="txtIniDescargaHora" #txtIniDescargaHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="Inicio_descarga_hora"
                                    (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtIniDescargaHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_descarga_hora)}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Descarga Data</mat-label>
                                <input matInput id="txtFimDescargaData" #txtFimDescargaData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="Termino_descarga_data" (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFimDescargaData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_descarga_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Descarga Hora</mat-label>
                                <input matInput id="txtFimDescargaHora" #txtFimDescargaHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="Termino_descarga_hora"
                                    (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFimDescargaHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_descarga_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo total de descarga
                                    {{hintHourResult}}</mat-label>
                                <input matInput id="txtTotalDescarga" #txtTotalDescarga readonly
                                    formControlName="Tempo_Total_de_descarga" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtTotalDescarga.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_Total_de_descarga)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Amostra seca ou molhada</mat-label>
                                <mat-select formControlName="Amostra_seca_molhada">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..." (keyup)="getListAmostra($event.target.value)">
                                    <mat-option *ngFor="let item of listAmostra" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Amostra_seca_molhada)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade de Recebimento</mat-label>
                                <input matInput id="txtUmidadeRecebimento" #txtUmidadeRecebimento maxlength="5"
                                    formControlName="Umidade_recebimento" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtUmidadeRecebimento.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_recebimento )}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Temperatura de Recebimento</mat-label>
                                <input matInput id="txtTemperaturaRecebimento" #txtTemperaturaRecebimento maxlength="5"
                                    formControlName="Temperatura_recebimento" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtTemperaturaRecebimento.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Temperatura_recebimento )}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso total RW</mat-label>
                                <input matInput id="txtPesoTotalRW" #txtPesoTotalRW maxlength="5"
                                    formControlName="Peso_total_rw" currencyMask readonly
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPesoTotalRW.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_total_rw )}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>